import AxiosApi from "axios";
import {
  ADD_REPORTITEM_FAIL,
  ADD_REPORTITEM_REQUEST,
  ADD_REPORTITEM_SUCCESS,
  ITEM_DETAILS_REQUEST,
  ITEM_DETAILS_SUCCESS,
  ITEM_DETAILS_FAIL,
  ALLRPTITEM_LIST_REQUEST,
  ALLRPTITEM_LIST_SUCCESS,
  ALLRPTITEM_LIST_FAIL,
} from "constants/FinanceReportConstants";

const Axios = AxiosApi.create({
  baseURL: process.env.REACT_APP_VIVOLEO_FINMAN_API,
});

export const addReportItemAction =
  (itemname, fromdate, todate, user, selectedcategories, otherinfo) =>
  async (dispatch) => {
    dispatch({
      type: ADD_REPORTITEM_REQUEST,
      payload: {
        itemname,
        fromdate,
        todate,
        user,
        selectedcategories,
        otherinfo,
      },
    });
    try {
      const { data } = await Axios.post("/api/financereport/addreportitem", {
        itemname,
        fromdate,
        todate,
        user,
        selectedcategories,
        otherinfo,
      });
      dispatch({ type: ADD_REPORTITEM_SUCCESS, payload: JSON.stringify(data) });
      localStorage.setItem("generatedrptitem", JSON.stringify(data));
    } catch (error) {
      dispatch({
        type: ADD_REPORTITEM_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const detailsItem = (itemname) => async (dispatch) => {
  dispatch({ type: ITEM_DETAILS_REQUEST, payload: itemname });
  console.log("detailsItemAction:" + itemname);
  try {
    const { data } = await Axios.get(`/api/financereport/rptitem/${itemname}`);
    dispatch({ type: ITEM_DETAILS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: ITEM_DETAILS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const listAllRptItem = () => async (dispatch) => {
  dispatch({
    type: ALLRPTITEM_LIST_REQUEST,
  });
  try {
    const { data } = await Axios.get(`/api/financereport/listallrptitems`);
    dispatch({ type: ALLRPTITEM_LIST_SUCCESS, payload: data });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    dispatch({ type: ALLRPTITEM_LIST_FAIL, payload: message });
  }
};
